import React, { useState, FormEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Ottieni l'URL da cui l'utente � stato reindirizzato
  const from = (location.state as any)?.from?.pathname || '/';

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    if (!username.trim() || !password.trim()) {
      setError('Inserire username e password');
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await login({ username, password });
      
      if (response.success) {
        navigate(from, { replace: true });
      } else {
        setError(response.message || 'Credenziali non valide');
      }
    } catch (err: any) {
      if (err.response?.status === 401) {
        setError('Credenziali non valide');
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Errore durante il login. Riprova.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">Pipeline App</h1>
          <p className="login-subtitle">Accedi al tuo account</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error">
              <span className="error-icon"></span>
              {error}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Username / Email
            </label>
            <input
              type="text"
              id="username"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Inserisci username o email"
              disabled={isSubmitting}
              autoComplete="username"
              autoFocus
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci password"
              disabled={isSubmitting}
              autoComplete="current-password"
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner"></span>
                Accesso in corso...
              </>
            ) : (
              'Accedi'
            )}
          </button>
        </form>
        
        <div className="login-footer">
          <p>Pipeline - Companion App</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
